export const MIN_NUMBER = 1;
export const MAX_NUMBER = 75;

export const PC_SIZE = '1024px';
export const TAB_SIZE = '680px';
export const SP_SIZE = '480px';
